import type { ReadonlyRecord } from '../../../../utils'

import type { PaginatedData, PaginationOptions } from '../../../../domain'

import type { BackendDefinition } from '../../../Connectware'

type BackendPagination = BackendDefinition<'service-manager', 'pagination'>

export const isLastPage = (pagination: BackendPagination): boolean => pagination.nextPage <= pagination.pageNumber

/**
 * Since backend starts counting pages at one,
 * an offset needs to be calculated both before it's sent to the BE and when received from the backend
 */
const pageOffset = 1

export const mapPaginationQueryParameters = ({ page, pageSize }: PaginationOptions): ReadonlyRecord<'page' | 'itemsPerPage', `${number}`> => ({
    page: `${page + pageOffset}`,
    itemsPerPage: `${pageSize}`,
})

export const mapPagination = (pagination: BackendPagination): Omit<PaginatedData<never>, 'current'> => ({
    totalCount: pagination.totalRows,
    page: pagination.pageNumber - pageOffset,
    pageSize: pagination.rowsPerPage,
})
